import React, { useState, useEffect } from 'react';
import { CDBSidebar, CDBSidebarHeader, CDBSidebarMenu, CDBSidebarMenuItem } from 'cdbreact';
import { NavLink, useNavigate } from 'react-router-dom';

function SideBar() {
  const [studentData, setStudentData] = useState({});
  const navigate = useNavigate();

  const authorization = async () => {
    try {
      const res = await fetch("/authorization-student", {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        credentials: "include",
      });
      const data = await res.json();
      setStudentData(data);

      if (res.status !== 200) {
        throw new Error("Unauthorized");
      }
    } catch (error) {
      navigate("/");
    }
  };

  useEffect(() => {
    authorization();
  }, []);

  return (
    <div className="h-[100vh] sticky top-0 left-0 bg-[#042e2e]">
      <CDBSidebar textColor="#fff" className="paymentPage w-[15rem] md:w-[16rem]" style={{ backgroundColor: '#042e2e' }}>
        <CDBSidebarHeader
          style={{ textDecoration: 'none', textAlign: 'center' }}
          className="py-0 border-b border-gray-600 mb-2"
          prefix={<i className="fa fa-bars fa-large mx-auto text-xl"></i>}
        >
        </CDBSidebarHeader>

        <CDBSidebarMenu>
          <NavLink exact to="/student-dashboard" className={({ isActive }) => `px-2 block mx-2 rounded-md ${isActive ? 'bg-[#074646]' : 'hover:bg-[#074646]/50'}`}>
            <CDBSidebarMenuItem icon="columns" className="py-1">Dashboard</CDBSidebarMenuItem>
          </NavLink>

          <NavLink exact to="/my-profile" className={({ isActive }) => `px-2 block mx-2 mt-2 rounded-md ${isActive ? 'bg-[#074646]' : 'hover:bg-[#074646]/50'}`}>
            <CDBSidebarMenuItem icon="user-alt" className="py-1">My Profile</CDBSidebarMenuItem>
          </NavLink>

          {/* <NavLink exact to="/student-dashboard" className={({ isActive }) => `px-2 block mx-2 mt-2 rounded-md ${isActive ? 'bg-[#074646]' : 'hover:bg-[#074646]/50'}`}>
            <CDBSidebarMenuItem icon="comment" className="py-1">My Queries</CDBSidebarMenuItem>
          </NavLink> */}

          <NavLink exact to="/my-payments" className={({ isActive }) => `px-2 block mx-2 mt-2 rounded-md ${isActive ? 'bg-[#074646]' : 'hover:bg-[#074646]/50'}`}>
            <CDBSidebarMenuItem icon="credit-card" className="py-1">My Payments</CDBSidebarMenuItem>
          </NavLink>

          <NavLink exact to="/contact-us" className={({ isActive }) => `px-2 block mx-2 mt-2 rounded-md ${isActive ? 'bg-[#074646]' : 'hover:bg-[#074646]/50'}`}>
            <CDBSidebarMenuItem icon="phone-square" className="py-1">Contact Us</CDBSidebarMenuItem>
          </NavLink>
        </CDBSidebarMenu>
      </CDBSidebar>
    </div>
  );
}

export default SideBar;